import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './session.types';

export const sessionSelectors = {
  ...generateResourceSelectors<types.ISession>((state) => state.resource.session),
};
